<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 9999">
  <div
    *ngFor="let toast of toasts"
    class="toast show align-items-center border-0"
    [ngClass]="getToastClass(toast.type)"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="d-flex w-100">
      <div class="toast-body d-flex align-items-center text-white">
        <mat-icon class="me-2">{{ getIcon(toast.type) }}</mat-icon>
        <span>{{ toast.message }}</span>
      </div>
      <button
        type="button"
        [class.btn-close-white]="isWhiteClose(toast.type)"
        class="btn-close me-2 m-auto"
        (click)="removeToast(toast.id)"
        aria-label="Cerrar"
      ></button>
    </div>
  </div>
</div>
